import * as React from "react";
const SvgUzpruvoLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 698 160"
    {...props}
  >
    <path
      fill="url(#uzpruvo-logo_svg__a)"
      d="M227.899 127.682c-27.187 0-52.164-7.63-81.804-24.79-9.535-5.525-17.239-12.154-24.701-18.61C106.263 71.195 93.17 59.94 69.817 63.253c-18.758 2.659-35.755 13.88-57.726 59.974a3.94 3.94 0 0 1-5.25 1.865 3.934 3.934 0 0 1-1.866-5.248c23.49-49.271 42.457-61.39 63.737-64.394 26.911-3.833 41.938 9.15 57.864 22.892 7.186 6.18 14.613 12.602 23.491 17.747 31.161 18.023 56.759 25.067 85.571 23.513 5.389-.276 10.778-.932 16.063-1.899 2.142-.414 4.215 1.001 4.595 3.142a3.906 3.906 0 0 1-3.178 4.592 136 136 0 0 1-17.1 2.037c-2.73.138-5.424.207-8.119.207"
    />
    <path
      fill="#392466"
      d="M68.09 148.675c-18.758 0-39.935-8.321-61.699-23.651-1.796-1.243-2.21-3.729-.967-5.49 1.243-1.796 3.73-2.21 5.492-.967 24.77 17.436 48.088 24.998 67.883 21.234 12.195-2.313 25.253-8.977 39.106-15.986 14.579-7.423 31.126-15.813 49.194-20.302 4.456-1.105 11.434-2.589 20.347-2.624 16.064-.034 28.017 4.592 33.786 6.837l.898.345c16.271 6.249 36.377 9.391 59.73 9.391l11.227-.069c2.211 0 3.973 1.761 3.973 3.936 0 2.176-1.762 3.971-3.938 3.971l-11.227.069h-.242c-24.251 0-45.221-3.349-62.321-9.909l-.933-.346c-5.251-2.037-16.167-6.284-30.573-6.284h-.311c-8.049.035-14.405 1.381-18.482 2.383-17.204 4.247-32.611 12.084-47.5 19.68-14.337 7.286-27.914 14.191-41.214 16.712a65 65 0 0 1-12.195 1.139z"
    />
    <path
      fill="url(#uzpruvo-logo_svg__b)"
      d="M173.317 140.734c-.864 0-1.727 0-2.557-.069-23.007-1.209-36.722-12.845-49.953-24.1-11.573-9.841-22.524-19.129-39.451-21.546-21.764-3.107-45.36 6.837-70.163 29.521a3.946 3.946 0 0 1-5.597-.241 3.94 3.94 0 0 1 .242-5.594c26.635-24.342 52.406-34.942 76.589-31.489 19.173 2.728 31.505 13.19 43.458 23.341 12.817 10.876 24.942 21.165 45.255 22.201 11.297.587 29.054-3.66 46.223-7.769 15.995-3.832 31.126-7.423 41.662-7.423l35.513-.207c2.177 0 3.973 1.726 3.973 3.936 0 2.175-1.727 3.97-3.938 3.97l-35.513.208c-9.639 0-25.011 3.66-39.866 7.216-16.548 3.97-33.613 8.045-45.912 8.045z"
    />
    <path
      fill="#392466"
      d="M374.167 110.626v21.303a1.916 1.916 0 0 1-1.9 1.899c-1.037 0-1.935-.863-1.935-1.899v-1.726c-1.9 2.106-5.044 4.04-8.809 4.04-3.766 0-7.877-2.486-7.877-7.873v-15.744c0-1.036.864-1.899 1.935-1.899s1.9.863 1.9 1.899v14.57c0 4.351 2.211 5.628 5.527 5.628s5.873-1.726 7.324-3.729V110.66c0-1.035.864-1.899 1.9-1.899s1.935.864 1.935 1.899zM380.592 129.927c0-.933.76-1.692 1.693-1.692s.726.103 1.036.311c1.797 1.484 4.25 2.555 7.013 2.555s5.839-1.692 5.839-4.075-3.006-3.591-6.322-4.385c-4.18-.966-8.948-2.106-8.948-7.216s3.317-7.113 9.189-7.113c5.873 0 6.184 1.14 8.188 2.694.345.31.656.759.656 1.277 0 .863-.76 1.623-1.623 1.623-.864 0-.657-.138-.933-.345-1.52-1.347-3.731-2.141-6.288-2.141-2.556 0-5.458 1.519-5.458 3.729s2.798 3.176 6.046 3.936c4.283.967 9.258 2.21 9.258 7.665s-3.316 7.458-9.707 7.458-6.391-.932-8.844-2.9a1.69 1.69 0 0 1-.726-1.381zM417.315 131.964c0 .725-.346 1.174-.968 1.415-.863.518-1.934.829-3.489.829-3.627 0-5.458-2.106-5.458-5.766v-16.159h-2.591a1.695 1.695 0 0 1-1.693-1.692c0-.932.76-1.692 1.693-1.692h2.591v-5.041c0-1.035.864-1.899 1.934-1.899 1.071 0 1.9.864 1.9 1.899v5.041h3.524c.933 0 1.727.76 1.727 1.692 0 .933-.829 1.692-1.727 1.692h-3.524v15.33c0 1.83.83 3.177 2.488 3.177s1.416-.449 1.934-.449c.968 0 1.624.656 1.624 1.657zM432.895 108.312c7.462 0 11.849 5.836 11.849 12.258s-.829 1.933-2.245 1.933h-17.723c.311 4.661 3.593 8.529 8.913 8.529s4.699-.829 6.633-2.348c.242-.138.553-.208.864-.208.863 0 1.589.657 1.589 1.52s-.242.966-.656 1.277c-2.453 1.899-5.355 2.901-8.81 2.901-7.323 0-12.574-5.249-12.574-12.983 0-7.147 5.112-12.913 12.16-12.913zm-8.119 11.395h16.203c-.07-3.695-2.488-8.218-8.119-8.218s-7.876 4.454-8.084 8.218M471.897 131.86c0 1.071-.829 1.934-1.9 1.934s-1.071-.138-1.485-.622l-9.051-10.634-4.18 3.867v5.455c0 1.036-.864 1.899-1.935 1.899s-1.9-.863-1.9-1.899v-30.695c0-1.036.864-1.899 1.934-1.899 1.071 0 1.901.863 1.901 1.899v20.889l13.334-12.913c.346-.345.76-.449 1.209-.449.968 0 1.728.829 1.728 1.796 0 .966-.208.932-.519 1.208l-8.843 8.494 9.189 10.358c.311.38.449.863.449 1.278zM477.563 101.372c0-1.415 1.174-2.59 2.556-2.59s2.626 1.175 2.626 2.59c0 1.416-1.175 2.555-2.626 2.555a2.53 2.53 0 0 1-2.556-2.555m.691 30.557v-21.303c0-1.036.863-1.899 1.934-1.899s1.9.863 1.9 1.899v21.303c0 1.036-.864 1.899-1.934 1.899-1.037 0-1.9-.863-1.9-1.899M510.761 116.288v15.641c0 1.036-.863 1.899-1.934 1.899s-1.9-.863-1.9-1.899v-14.467c0-4.35-2.211-5.731-5.528-5.731s-5.873 1.83-7.323 3.832v16.366a1.916 1.916 0 0 1-1.9 1.899c-1.037 0-1.935-.863-1.935-1.899v-21.303c0-1.036.864-1.899 1.9-1.899s1.935.863 1.935 1.899v1.933c1.692-2.037 5.009-4.247 8.809-4.247 5.182 0 7.876 2.59 7.876 7.976M539.434 110.626v21.303a1.916 1.916 0 0 1-1.9 1.899c-1.036 0-1.934-.863-1.934-1.899v-1.726c-1.9 2.106-5.044 4.04-8.809 4.04-3.766 0-7.877-2.486-7.877-7.873v-15.744c0-1.036.864-1.899 1.935-1.899s1.9.863 1.9 1.899v14.57c0 4.351 2.211 5.628 5.527 5.628s5.873-1.726 7.324-3.729V110.66c0-1.035.863-1.899 1.9-1.899s1.934.864 1.934 1.899zM581.235 115.77v16.159c0 1.036-.933 1.899-1.935 1.899s-1.9-.863-1.9-1.899v-15.088c0-3.108-1.382-5.11-4.56-5.11s-5.251 1.83-6.529 3.763v16.401a1.916 1.916 0 0 1-1.9 1.899c-1.036 0-1.935-.863-1.935-1.899v-15.089c0-3.107-1.347-5.11-4.56-5.11s-5.147 1.83-6.494 3.833v16.366a1.916 1.916 0 0 1-1.9 1.899c-1.037 0-1.935-.863-1.935-1.899v-21.304c0-1.036.864-1.899 1.9-1.899s1.935.863 1.935 1.899v1.899c.967-1.519 4.283-4.178 7.98-4.178s5.942 2.038 6.633 4.593c1.382-2.245 4.698-4.593 8.291-4.593 4.525 0 6.909 2.486 6.909 7.458M608.699 116.634v15.261c0 1.036-.864 1.899-1.935 1.899s-1.9-.863-1.9-1.899v-1.14c-1.934 2.245-4.802 3.419-8.187 3.419-3.386 0-8.637-2.797-8.637-8.183 0-5.387 4.457-8.114 8.637-8.114s6.184 1.07 8.187 3.383v-4.454c0-3.314-2.66-5.213-6.253-5.213s-4.491.725-6.425 2.451c-.242.138-.622.311-1.036.311-.864 0-1.59-.725-1.59-1.588s.311-1.036.657-1.278c2.487-2.21 5.354-3.211 8.913-3.211 5.216 0 9.569 2.348 9.569 8.321zm-3.835 11.773v-4.661c-1.485-2.037-4.076-3.073-6.805-3.073s-6.08 2.245-6.08 5.421 2.487 5.352 6.08 5.352c2.694 0 5.32-1.036 6.805-3.073zM640.032 121.295c0 8.01-4.56 12.913-10.986 12.913-6.425 0-6.425-1.795-8.325-4.281v2.002a1.916 1.916 0 0 1-1.9 1.899c-1.037 0-1.935-.863-1.935-1.899v-30.695c0-1.035.864-1.899 1.935-1.899s1.9.864 1.9 1.899v11.498c1.934-2.762 5.009-4.385 8.325-4.385 6.426 0 10.986 5.11 10.986 12.982zm-3.973 0c0-5.456-2.971-9.564-7.98-9.564s-6.045 1.83-7.358 3.97v11.187c1.347 2.141 4.353 3.867 7.358 3.867 5.009 0 7.98-4.039 7.98-9.495z"
    />
    <path
      fill="#E67B69"
      d="M652.745 11.325c-5.493 0-9.984 4.489-9.984 9.978 0 5.49 4.491 9.979 9.984 9.979s9.984-4.489 9.984-9.979a9.94 9.94 0 0 0-9.984-9.978m0 17.678c-4.249 0-7.704-3.453-7.704-7.7s3.386-7.7 7.704-7.7 7.704 3.385 7.704 7.7c0 4.247-3.455 7.7-7.704 7.7"
    />
    <path
      fill="#E67B69"
      d="M656.787 19.37c0-2.003-1.831-3.246-3.559-3.246h-3.074a1.15 1.15 0 0 0-1.14 1.14v8.114c0 .587.483 1.035 1.105 1.035s1.037-.483 1.037-1.035v-2.832h1.382L654.783 26c.207.242.518.415.864.415.691 0 1.105-.518 1.105-1.036s-.069-.415-.173-.587l-1.658-2.486c.691-.311 1.9-1.14 1.9-2.935zm-2.177 0c0 .76-.725 1.243-1.382 1.243h-2.072v-2.59h2.072c.657 0 1.382.518 1.382 1.347"
    />
    <path
      fill="url(#uzpruvo-logo_svg__c)"
      d="M196.324 17.23c-3.42 0-6.114 2.796-6.114 6.11v35.944c0 10.98-6.115 18.126-17.619 18.126s-17.722-7.147-17.722-18.126V23.34c0-3.315-2.694-6.112-6.114-6.112s-6.115 2.797-6.115 6.111v36.358c0 16.987 9.846 28.485 29.951 28.485 20.106 0 29.848-11.394 29.848-28.589V23.341c0-3.315-2.695-6.112-6.115-6.112"
    />
    <path
      fill="url(#uzpruvo-logo_svg__d)"
      d="M265.554 76.271h-31.298l34.615-47.648c.829-1.036 1.347-2.486 1.347-3.936 0-3.832-3.109-6.836-6.84-6.836H223.27c-2.902 0-5.389 2.382-5.389 5.386s2.487 5.283 5.389 5.283h30.573l-34.615 47.648c-.829 1.035-1.347 2.485-1.347 3.936 0 3.832 3.109 6.836 6.84 6.836h40.833c2.902 0 5.389-2.382 5.389-5.386s-2.487-5.283-5.389-5.283"
    />
    <path
      fill="url(#uzpruvo-logo_svg__e)"
      d="M316.855 17.85h-23.94c-4.146 0-6.426 2.28-6.426 6.423V81.45c0 3.315 2.695 6.111 6.115 6.111s6.011-2.796 6.011-6.11V61.147h18.24c14.406 0 22.593-9.944 22.593-21.649s-8.084-21.648-22.593-21.648m-1.658 32.63h-16.582V28.52h16.582c6.84 0 11.815 4.35 11.815 10.98 0 6.629-4.975 10.98-11.815 10.98"
    />
    <path
      fill="url(#uzpruvo-logo_svg__f)"
      d="M392.303 59.387c7.566-2.072 14.302-8.597 14.302-19.888 0-11.29-8.912-21.648-22.593-21.648h-23.94c-4.145 0-6.426 2.279-6.426 6.422V81.45c0 3.315 2.695 6.111 6.115 6.111s6.011-2.796 6.011-6.11V61.147h14.095l16.271 23.824c1.14 1.554 3.109 2.59 5.078 2.59 3.42 0 5.7-3.108 5.7-5.49s-.518-2.9-1.14-3.833zm-9.949-8.908h-16.582V28.52h16.582c6.84 0 11.815 4.351 11.815 10.98s-4.975 10.98-11.815 10.98"
    />
    <path
      fill="url(#uzpruvo-logo_svg__g)"
      d="M476.561 17.23c-3.42 0-6.115 2.796-6.115 6.11v35.944c0 10.98-6.114 18.126-17.618 18.126s-17.722-7.147-17.722-18.126V23.34c0-3.315-2.695-6.112-6.115-6.112s-6.115 2.797-6.115 6.111v36.358c0 16.987 9.846 28.485 29.952 28.485s29.847-11.394 29.847-28.589V23.341c0-3.315-2.694-6.112-6.114-6.112"
    />
    <path
      fill="url(#uzpruvo-logo_svg__h)"
      d="M554.6 17.23a6.4 6.4 0 0 0-6.011 4.142l-19.588 52.413-19.587-52.412a6.4 6.4 0 0 0-6.011-4.144c-2.695 0-6.426 2.9-6.426 6.422s.208 1.554.519 2.28l21.453 54.794c1.554 3.936 5.492 6.837 10.052 6.837 4.561 0 8.499-2.9 10.053-6.837l21.453-54.795c.311-.725.519-1.45.519-2.279 0-3.521-2.902-6.422-6.426-6.422"
    />
    <path
      fill="url(#uzpruvo-logo_svg__i)"
      d="M605.59 16.711c-20.728 0-35.341 15.123-35.341 35.736s14.613 35.736 35.341 35.736c20.727 0 35.34-15.123 35.34-35.736s-14.613-35.736-35.34-35.736m0 60.7c-13.991 0-22.904-10.773-22.904-24.964s8.913-24.963 22.904-24.963 22.904 10.669 22.904 24.963-9.017 24.963-22.904 24.963"
    />
    <path fill="#181716" d="M682.316 37.497 697.275 11.6h-29.917z" />
    <defs>
      <linearGradient
        id="uzpruvo-logo_svg__b"
        x1={4.56}
        x2={298.511}
        y1={113.699}
        y2={113.699}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#392466" />
        <stop offset={0.2} stopColor="#905067" />
        <stop offset={0.3} stopColor="#E67B69" />
        <stop offset={0.9} stopColor="#392466" />
      </linearGradient>
      <linearGradient
        id="uzpruvo-logo_svg__c"
        x1={141.293}
        x2={645.041}
        y1={52.62}
        y2={53.83}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#382466" />
        <stop offset={1} stopColor="#E57B69" />
      </linearGradient>
      <linearGradient
        id="uzpruvo-logo_svg__d"
        x1={141.569}
        x2={643.97}
        y1={52.413}
        y2={52.413}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#382466" />
        <stop offset={1} stopColor="#E57B69" />
      </linearGradient>
      <linearGradient
        id="uzpruvo-logo_svg__e"
        x1={141.293}
        x2={645.041}
        y1={52.309}
        y2={53.553}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#382466" />
        <stop offset={1} stopColor="#E57B69" />
      </linearGradient>
      <linearGradient
        id="uzpruvo-logo_svg__f"
        x1={141.293}
        x2={645.041}
        y1={52.171}
        y2={53.381}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#382466" />
        <stop offset={1} stopColor="#E57B69" />
      </linearGradient>
      <linearGradient
        id="uzpruvo-logo_svg__g"
        x1={141.293}
        x2={645.041}
        y1={51.929}
        y2={53.173}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#382466" />
        <stop offset={1} stopColor="#E57B69" />
      </linearGradient>
      <linearGradient
        id="uzpruvo-logo_svg__h"
        x1={141.293}
        x2={645.041}
        y1={51.446}
        y2={52.656}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#382466" />
        <stop offset={1} stopColor="#E57B69" />
      </linearGradient>
      <linearGradient
        id="uzpruvo-logo_svg__i"
        x1={141.293}
        x2={645.041}
        y1={51.342}
        y2={52.552}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#382466" />
        <stop offset={1} stopColor="#E57B69" />
      </linearGradient>
      <radialGradient
        id="uzpruvo-logo_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(159.222 0 0 159.137 164.922 96.09)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.2} stopColor="#E67B69" />
        <stop offset={0.8} stopColor="#915067" />
        <stop offset={0.9} stopColor="#392466" />
      </radialGradient>
    </defs>
  </svg>
);
export default SvgUzpruvoLogo;
